(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lov-drop-4-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lov-drop-4-video')) {
    customElements.define('lov-drop-4-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.loop = true;
        this.video.playsInline = true;
        this.slide = this.closest('slideshow-slide');

        if (this.slide) {
          this.slideObserver = new MutationObserver(() => {
            if (this.slide.getAttribute('aria-hidden') === 'true') {
              this.video.pause();
            } else if (this.visible) {
              this.video.play().catch(() => {});
            }
          });

          this.slideObserver.observe(this.slide, {
            attributes: true,
            attributeFilter: ['aria-hidden']
          });
        }

        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            this.visible = entry.isIntersecting && entry.intersectionRatio > 0;

            if (
              this.visible &&
              (!this.slide || this.slide.getAttribute('aria-hidden') === 'false')
            ) {
              this.video.play().catch(() => {});
            } else {
              this.video.pause();
            }
          }
        }, { threshold: [0, 0.01] });

        this.observer.observe(this.video);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.slideObserver?.disconnect();
        this.video?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
